export default __webpack_public_path__ + "static/media/error404.d916c7d4.svg";